export enum EnumCajuInterest {
  ALREADY_KNOW = "Já conheço a Caju e quero contratar :)",
  WATCH_DEMO = "Assistir demonstração para conhecer e tirar dúvidas",
  HIRE = "Quero contratar",
  TALK_TO_CONSULTANT = "Quero falar com um consultor",
}
